import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { additionalValue } from '@/react-query/context/ApiClientContextController';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { hostListQueries } from '@/services/hostManagement/hostManagement.queries';
import { useParams, useSearch } from '@tanstack/react-router';

export const useHostList = () => {
  const search = useSearch({ from: '/(app)/store-information/basic-stores/host-management/$clubid/' });
  const clubId = useParams({ from: '/(app)/store-information/basic-stores/host-management/$clubid/' });

  const { createdDate, page, fetch } = search;
  const parsedCreatedDate = parseDateRangeSearch(createdDate, { start: 0, end: 0 });
  const { data, isLoading } = useQuery({
    ...hostListQueries.list({
      clubId: clubId['clubid'] || '',
      fromDate: Number(parsedCreatedDate?.start) || 0,
      toDate: Number(parsedCreatedDate?.end) || 0,
      row: page ?? 0,
      fetch: fetch ?? 10,
      search: search.q ?? '',
    }),
    enabled: !!clubId.clubid,
    select: (res) => ({
      ...res,
      data: sortBy(res.data, search.sort),
    }),
  });
  return {
    getHostList: data?.data || [],
    isLoading,
    pagination: data?.meta?.pagination || defaultMeta,
    commonClubId: (data?.meta?.additionalValue || '') as additionalValue,
  };
};
